export enum ButtonVariant {
  p = 'primary',
  s = 'secondary',
  d = 'danger',
  g = 'ghost',
}
